import {HttpErrorResponse} from '@angular/common/http';
import {Injectable, NgZone} from '@angular/core';
import {AnalyticsService} from '@npck/libs/analytics-sdk';
import {CommonError, CommonErrorHandler, ERROR_PARAM, ERROR_PATH, RouterService} from '@npck/libs/commons';
import {DialogService, SnackbarService} from '@npck/libs/ui-kit';
import {AuthHolderService} from '../domain/auth-holder.service';
import {PROFILE_ERROR, PROFILE_SESSION_EXPIRED} from './analytics-events';

@Injectable()
export class AppErrorHandler extends CommonErrorHandler {
    constructor(
        zone: NgZone,
        routerService: RouterService,
        private analyticsService: AnalyticsService,
        private authHolderService: AuthHolderService,
        private dialogService: DialogService,
        private snackbarService: SnackbarService,
    ) {
        super(zone, routerService);
    }

    hideAllUiElements(): void {
        super.hideAllUiElements();
        this.dialogService.closeAllDialogs();
        this.snackbarService.dismiss();
    }

    handleAccessError(error: HttpErrorResponse): void {
        if (this.authHolderService.isUser) {
            this.analyticsService.capture(PROFILE_SESSION_EXPIRED);
        }
        this.authHolderService.logout();
    }

    handleServerError(error: any): void {
        if (this.authHolderService.isUser) {
            const url = new URL(window.location.href);
            this.analyticsService.capture(PROFILE_ERROR, {drop_path: url.pathname, reason: error});
        }
        super.handleServerError(error);
    }

    handleNetworkError(): void {
        this.routerService.navigate(ERROR_PATH, {[ERROR_PARAM]: CommonError.NETWORK_ERROR});
    }
}

export enum Error {
    MODERATOR_FORBIDDEN = 'MODERATOR_FORBIDDEN',
    IIN_BLOCKED = 'IIN_BLOCKED'
}
